import { createGlobalStyle } from 'styled-components';
import { fontFaces } from './fontFaces';

const GlobalStyles = createGlobalStyle`
    ${fontFaces
      .map(
        (face) => `
        @font-face {
        font-family: '${face.family}';
        ${face.weights
          .map(
            (weight) =>
              `src: ${weight.src}; format('${weight.format}'); weight:${weight.weight}`
          )
          .join('\n      ')}
        font-style: ${face.options.style};
        font-display: ${face.options.display};
        }
    `
      )
      .join('\n')}

  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: 'SF Pro Text', sans-serif;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: none;
  }
    
  html {
    height: 100%;
  }
  
  body {
        width: 100%;
        min-width: 350px;
    
        > * {
          width: 100%;
          height: 100%; 
        }
        
        &.storeV2 {
          @media (prefers-color-scheme: dark) {
            background-color: #000000;
          }
        }
  }
    
    input[type="text"],
    input[type="tel"],
    input[type="email"],
    input[type="password"],
    input[type="tel"],
    input[type="textarea"],
    input[type="radio"],
    textarea,
    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    
    input[type="radio"] {
        display: none;
    }
    
    a, input, button {
        font-family: 'SF Pro Text', sans-serif;
    }
`;

export default GlobalStyles;
